import { z } from 'zod';
import { EventForm, EventFormState } from './events';
import { ExpenseReportForm, ExpenseReportFormState } from './expense-reports';
import { NoticeForm, NoticeFormState } from './notices';

export type Form = EventForm | NoticeForm | ExpenseReportForm;

export type FormState = EventFormState | NoticeFormState | ExpenseReportFormState;

export const zodNumberFromString = z.preprocess((val) => {
  if (typeof val === 'string' && val.trim() !== '') {
    const parsed = Number(val);
    if (!isNaN(parsed)) return parsed;
  }
  return val; // let Zod throw if it's not a valid number
}, z.number());

export const zodUploadedFileMetadataSchema = z.object({
  id: z.string(), // Logical identifier (e.g. UUID used in filename or key)
  location: z.string(), // Storage location (e.g. bucket, disk partition, etc.)
  originalName: z.string(),
  uploadedAt: z.string().datetime(),
  contentType: z.string().optional(),
  size: zodNumberFromString,
});

export type UploadedFileMetadata = z.infer<typeof zodUploadedFileMetadataSchema>;

export const zodSignedUrlSchema = z.object({
  name: z.string(), // File display name
  id: z.string(), // File ID in storage
  signedUrl: z.string().url(), // URL authorized to view the file
});

export type SignedUrl = z.infer<typeof zodSignedUrlSchema>;
